var o = /* @__PURE__ */ ((r) => (r.GOOGLE = "google", r.FACEBOOK = "facebook", r.TWITTER = "twitter", r.APPLE = "apple", r.REGISTER = "register", r.LOGIN = "login", r))(o || {});
export {
  o as AuthType
};
